import './App.css';

/**
 * Renders a group of checkboxes based on the provided question data.
 * 
 * @param {Object} props - The component props.
 * @param {string} props.id - Unique identifier for the checkbox group.
 * @param {Array} props.currentQuestion - Array of objects representing each checkbox option.
 * @param {Object} props.value - Object containing the current checked state of checkboxes.
 * @param {Function} props.onChange - Callback function to handle checkbox state changes.
 * @returns {JSX.Element} A React fragment containing checkbox inputs and labels.
 */
function Checkbox({ id, currentQuestion, value, onChange, props }) {

    // Handle checkbox change event and update state
    const handleChange = (event) => {
        const { name, checked } = event.target;
        onChange(id, name, checked);
    };

  return (
    <>
        {currentQuestion.map((box, index) => (
            <div key={index} className='checkbox-wrapper'>
                <input type="checkbox" id={`${id}-${index}`} name={box.value} value={box.value} onChange={handleChange} defaultChecked={value[box.value] || ''}/>
                <label htmlFor={`${id}-${index}`} dangerouslySetInnerHTML={{__html: box.label}}></label>
            </div>
        ))}
    </>
  );
}

export default Checkbox;